import { SET_CLIENTS } from './constants';


const defaultState = {
    clients: [],
};

const clientsReducer = (state = defaultState, action) => {
    switch (action.type) {
        case SET_CLIENTS:
            return { ...state, clients: action.clients };

        default:
            return state;
    }
};

export default clientsReducer;



// WEBPACK FOOTER //
// ./src/containers/common/clients/reducer.js